export const styles = {
    /* ── Page ── */
    pageWrapper: {
        padding: '24px 32px',
        minHeight: '100vh',
        background: '#f8fafb',
        fontFamily: 'inherit',
        overflowY: 'auto',
        height: '100vh',
        boxSizing: 'border-box',
    },

    /* ── Top bar ── */
    pageHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        marginBottom: '28px',
        position: 'relative',
    },
    btnBack: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        padding: '7px 16px',
        fontSize: '13px',
        fontWeight: '600',
        color: '#1a7d3e',
        backgroundColor: '#fff',
        border: '1.5px solid #bbf7d0',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        whiteSpace: 'nowrap',
        flexShrink: 0,
    },
    headerCenter: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
    },
    pageTitleIcon: {
        width: '38px',
        height: '38px',
        borderRadius: '10px',
        background: 'linear-gradient(135deg, #1a7d3e 0%, #34a85a 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        boxShadow: '0 2px 8px rgba(26,125,62,0.25)',
    },
    pageTitleBlock: {
        display: 'flex',
        flexDirection: 'column',
    },
    pageTitle: {
        fontSize: '18px',
        fontWeight: '700',
        color: '#111827',
        margin: 0,
        lineHeight: 1.2,
    },
    pageSubtitle: {
        fontSize: '12px',
        color: '#9ca3af',
        marginTop: '2px',
    },
    userPill: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '4px 12px',
        backgroundColor: '#dcfce7',
        color: '#1a7d3e',
        borderRadius: '20px',
        fontSize: '12.5px',
        fontWeight: '600',
        flexShrink: 0,
        position: 'absolute',
        right: 0,
    },
    userPillDot: {
        width: '7px',
        height: '7px',
        borderRadius: '50%',
        background: '#1a7d3e',
        flexShrink: 0,
    },

    /* ── Section heading ── */
    sectionHeading: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '12px',
    },
    sectionBar: {
        width: '4px',
        height: '18px',
        borderRadius: '3px',
        background: 'linear-gradient(135deg, #1a7d3e 0%, #34a85a 100%)',
        flexShrink: 0,
    },
    sectionTitle: {
        fontSize: '14px',
        fontWeight: '700',
        color: '#111827',
        margin: 0,
    },
    sectionBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '3px',
        fontSize: '11px',
        fontWeight: '600',
        color: '#1a7d3e',
        backgroundColor: '#dcfce7',
        borderRadius: '20px',
        padding: '3px 10px',
        whiteSpace: 'nowrap',
    },

    /* ── Assignment card ── */
    assignCard: {
        background: '#fff',
        border: '1.5px solid #e5e7eb',
        borderRadius: '14px',
        padding: '18px 22px',
        marginBottom: '14px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
        transition: 'box-shadow 0.15s ease, border-color 0.15s ease',
        overflow: 'visible',
    },
    assignCardNew: {
        background: '#fff',
        border: '1.5px solid #d1fae5',
        borderRadius: '14px',
        padding: '18px 22px',
        marginBottom: '22px',
        boxShadow: '0 2px 8px rgba(26,125,62,0.08)',
        overflow: 'visible',
    },
    formRow: {
        display: 'flex',
        alignItems: 'flex-end',
        gap: '16px',
        flexWrap: 'wrap',
    },
    formItem: {
        flex: 1,
        minWidth: '160px',
        display: 'flex',
        flexDirection: 'column',
        gap: '5px',
    },
    fieldLabel: {
        fontSize: '11.5px',
        fontWeight: '700',
        color: '#1a7d3e',
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
    },
    errorText: {
        fontSize: '11.5px',
        color: '#dc2626',
        marginTop: '3px',
        fontWeight: '500',
    },

    /* ── Manager toggle block ── */
    managerBlock: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '4px',
        paddingBottom: '2px',
        flexShrink: 0,
    },
    managerLabel: {
        fontSize: '11.5px',
        fontWeight: '700',
        color: '#1a7d3e',
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
    },

    /* ── Action buttons ── */
    actionBlock: {
        display: 'flex',
        alignItems: 'flex-end',
        gap: '8px',
        flexShrink: 0,
        paddingBottom: '2px',
    },
    btnSave: {
        height: '36px',
        padding: '0 22px',
        fontSize: '13px',
        fontWeight: '600',
        color: '#fff',
        backgroundColor: '#1a7d3e',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'background-color 0.15s ease',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        boxShadow: '0 2px 6px rgba(26,125,62,0.25)',
        whiteSpace: 'nowrap',
    },
    btnUpdate: {
        height: '36px',
        padding: '0 20px',
        fontSize: '13px',
        fontWeight: '600',
        color: '#fff',
        backgroundColor: '#1a7d3e',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'background-color 0.15s ease',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        boxShadow: '0 2px 6px rgba(26,125,62,0.2)',
        whiteSpace: 'nowrap',
    },
    btnDelete: {
        height: '36px',
        padding: '0 16px',
        fontSize: '13px',
        fontWeight: '600',
        color: '#dc2626',
        backgroundColor: '#fff5f5',
        border: '1.5px solid #fee2e2',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        whiteSpace: 'nowrap',
    },

    /* ── Card index chip ── */
    cardIndexChip: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        background: 'linear-gradient(135deg, #1a7d3e 0%, #34a85a 100%)',
        color: '#fff',
        fontSize: '11px',
        fontWeight: '700',
        flexShrink: 0,
        marginBottom: '12px',
    },

    /* ── Empty state ── */
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 0',
        color: '#9ca3af',
    },
    emptyText: {
        marginTop: '12px',
        fontSize: '14px',
        color: '#9ca3af',
        fontWeight: '500',
    },
};
